export default {
    setProfile(state, payload) {
        state.profile = payload
    },
}
